import type { IValidationField } from '../types';
import * as yup from 'yup';
import { t } from 'i18next';
import { MAX_NUMBER_LIMIT } from 'appConstants';

export default function requiredPositiveNumber({ label = '', context }: IValidationField) {
  const { maxValue = MAX_NUMBER_LIMIT } = context || {};

  return yup
    .number()
    .label(label)
    .min(1)
    .required()
    .positive()
    .max(maxValue)
    .test({
      name: 'valid_integer',
      test: (value, context) => {
        const regex = /^[0-9]*$/g;
        const { originalValue, path = '' } = context;
        if (!originalValue.toString().match(regex)) {
          return context.createError({
            message: t('errors.integerNumber'),
            path: path,
          });
        }

        return true;
      },
    })
    .integer(`${t('errors.integerNumber')}`)
    .typeError(`${t('errors.integerNumber')}`);
}
